/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";

const ScaledFullWidthImage = (props) => {

    const image = props?.image;
    const settings = props?.settings;
    const style_class = props?.style_class;
    const dimension = settings?.dimension ?? "100%";
    const forceSixteenNine = settings?.forceSixteenNine ?? false;
    // const contain = settings?.contain ?? false,
    const width = image?.width;
    const height = image?.height;
    const hasWidth = !!width;
    const hasHeight = !!height;
    let aspect_ratio;
    if (forceSixteenNine) {
        // use 16/9 default
        aspect_ratio = "16/9";
    } else if (hasWidth && hasHeight) {
        const longerSide = height >= width ? "height" : "width";
        aspect_ratio = (longerSide === "height") ? `${height}/${width}` : `${width}/${height}`;
    } else {
        // leave aspect_ratio undefined
    }


    return (
        <>
            {image &&
                <>
                    <img
                        src={image.url}
                        alt={image.alt}
                        width={dimension}
                        className={style_class}
                        style={{
                            aspectRatio: aspect_ratio
                        }}
                    />
                </>
            }
        </>
    );
};

export { ScaledFullWidthImage };
